import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';
import App from './views/App';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { BrowserRouter } from 'react-router-dom';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-toastify/dist/ReactToastify.min.css';
import * as Sentry from "@sentry/react";
import './index.scss';

const theme = createTheme({
  palette: {
    primary: {
      main: "#1481BA",
    },
  },
  overrides:{
    MuiButton:{
      contained:{
        color: "#1481BA",
      }
    }
  }
});

Sentry.init({
  dsn: "https://8bd63f96650edb0053bdda302c9b034b@o4508795906162688.ingest.de.sentry.io/4508795907801168",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  environment: process.env.NODE_ENV || "development",
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", "lcdf.fr"],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <App />
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
          />
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);

const promptRefresh = (registration) => {
  const closeToast = () => toast.dismiss('pwa-update');
  const reloadApp = () => {
    closeToast();

    if (registration?.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
  };

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    window.location.reload();
  }, { once: true });

  toast.info(
    <div className="pwa-toast">
      <strong>Mise à jour disponible</strong>
      <div>Une nouvelle version du site est prête.</div>
      <div className="pwa-toast-actions">
        <button type="button" onClick={reloadApp}>Mettre à jour</button>
        <button type="button" onClick={closeToast}>Plus tard</button>
      </div>
    </div>,
    {
      autoClose: false,
      closeOnClick: false,
      toastId: 'pwa-update',
    }
  );
};

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    promptRefresh(registration);
  },
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
